import { render, staticRenderFns } from "./ImgShow.vue?vue&type=template&id=f2bcc8a0&scoped=true&"
import script from "./ImgShow.vue?vue&type=script&lang=js&"
export * from "./ImgShow.vue?vue&type=script&lang=js&"
import style0 from "./ImgShow.vue?vue&type=style&index=0&id=f2bcc8a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bcc8a0",
  null
  
)

export default component.exports